import { Route, Redirect } from "react-router-dom";
import { useEffect } from "react";
import Loading from "../layout/Loading";
import { useAuthInfo } from "../../context/AuthContext";

const PrivateRoute = ({ component: Component, children, ...rest }) => {
  const { userInfo, isLoading } = useAuthInfo();

  useEffect(() => {
    const handleUnauthorized = (event) => {
      if (event.detail?.status === 401) {
        window.location.href = "/login";
      }
    };

    window.addEventListener("unauthorized", handleUnauthorized);
    return () => window.removeEventListener("unauthorized", handleUnauthorized);
  }, []);

  if (isLoading) {
    return <Loading isLoading={true} />;
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (userInfo) {
          return Component ? <Component {...props} /> : children;
        }

        if (!userInfo && props.location.pathname !== "/login") {
          return <Redirect to="/login" />;
        }

        return Component ? <Component {...props} /> : children;
      }}
    />
  );
};

export default PrivateRoute;
